import * as React from 'react';
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";

const renderRow = (props) => {
    const { index: key, style, data, handleCheck, CARD_ID } = props;
    const element = data[key];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [checked, setChecked] = React.useState(element.checked);

    return (
      <ListItem
        id={`item-` + CARD_ID + `-` + key}
        style={style}
        key={key}
        component="div"
        disablePadding
      >
        <ListItemIcon>
          <Checkbox
            // ref={`ref-simple-checkbox-` + CARD_ID + `-` + element.id}
            index={key}
            id={element.id.toString()}
            edge="start"
            inputProps={{
              "data-key": element.id,
              "aria-label": "controlled",
            }}
            disableRipple
            onChange={
              (e) => {
                setChecked(!checked);
                handleCheck(e, element.id)
              }
            }
            value={checked}
            checked={checked}
          />
        </ListItemIcon>
        <ListItemText primary={`${element.id} - ${element.name}`} />
      </ListItem>
    );
  };
  
  
export default renderRow;